/**************************************************
 * Nombre:       Casilla_Avatar_Titulo_Dato
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, TableCell, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";

const Casilla_Estado = ({estado = '', arrEstados = [], dir, index}) => {

    let index_ = arrEstados.findIndex((e) => e.nombre === estado)

    return (
        <TableCell key={`${index}we78s`} variant={'body'} align={dir} sx={{color: COLORTEXTO, fontSize: 14}}>
            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}
                   sx={{

                       backgroundColor: index_ > -1 ? arrEstados[index_].color + 20 : '#5d87ff10', borderRadius: 1.5

                   }}>

                <Typography
                    sx={{
                        textAlign: 'center',
                        fontWeight: 700,
                        color: index_ > -1 ? arrEstados[index_].color : '#5d87ff',
                        fontSize: 14
                    }}>{estado}</Typography>

            </Grid>
        </TableCell>

    )

}
export default Casilla_Estado